import { render, staticRenderFns } from "./AttachmentsIndicator.vue?vue&type=template&id=4aae08fc&"
import script from "./AttachmentsIndicator.vue?vue&type=script&lang=js&"
export * from "./AttachmentsIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports